import store from '../../../../../store';
import { apiClient } from '../../../../../v4/core/apiClient';
import { createServerFeatureFlagSource } from './serverFeatureFlagSource';

export const myServerFeatureFlagSource = createServerFeatureFlagSource(
  apiClient,
  store
);
